import React, { useState, useEffect, useCallback } from 'react';
import { API, C, authHeaders, when, btn, btnMain, inp } from './modApi';

/* ==================== MY PROFILE ==================== */
export function MyProfileTab({ me, onSaved }) {
  const p = me && me.profile;
  const [f, setF] = useState({
    display_name: '', country: '', country_code: '', city: '',
    timezone: '', hours: '', channels: '', languages: '',
  });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(function () {
    if (!p) return;
    setF({
      display_name: p.name || '', country: p.country || '',
      country_code: p.country_code || '', city: p.city || '',
      timezone: p.timezone || '', hours: p.hours || '',
      channels: p.channels || '', languages: p.languages || '',
    });
  }, [p]);

  if (!p) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;

  const save = async function () {
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/mods/' + p.id + '/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(f) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setMsg('Saved.');
      if (onSaved) onSaved();
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  const done = f.country && f.hours && f.channels && f.languages;

  return (
    <>
      {!done ? (
        <div style={{ background: '#FDF0DD', border: '1px solid ' + C.gold, borderRadius: 9, padding: '10px 12px', marginBottom: 11 }}>
          <p style={{ margin: 0, fontSize: 12.5, fontWeight: 700, color: C.gold }}>Complete your profile</p>
          <p style={{ margin: '3px 0 0', fontSize: 11.5, color: C.muted, lineHeight: 1.5 }}>
            The team needs to know where you are, when you are around, which channels
            you cover and which languages you can answer in. It takes a minute.
          </p>
        </div>
      ) : null}

      <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 13 }}>
        <p style={{ margin: '0 0 11px', fontSize: 13.5, fontWeight: 700 }}>My profile</p>

        <input value={f.display_name} onChange={function (e) { setF({ ...f, display_name: e.target.value }); }}
          placeholder="Display name" style={inp} />

        <div style={{ display: 'flex', gap: 7 }}>
          <input value={f.country} onChange={function (e) { setF({ ...f, country: e.target.value }); }}
            placeholder="Country" style={inp} />
          <input value={f.country_code} onChange={function (e) { setF({ ...f, country_code: e.target.value }); }}
            placeholder="Code (NG)" maxLength={2} style={{ ...inp, width: 90 }} />
        </div>

        <div style={{ display: 'flex', gap: 7 }}>
          <input value={f.city} onChange={function (e) { setF({ ...f, city: e.target.value }); }}
            placeholder="City" style={inp} />
          <input value={f.timezone} onChange={function (e) { setF({ ...f, timezone: e.target.value }); }}
            placeholder="Timezone (WAT)" style={inp} />
        </div>

        <input value={f.hours} onChange={function (e) { setF({ ...f, hours: e.target.value }); }}
          placeholder="When are you usually around? (7pm - 12am)" style={inp} />
        <input value={f.channels} onChange={function (e) { setF({ ...f, channels: e.target.value }); }}
          placeholder="Which channels do you moderate?" style={inp} />
        <input value={f.languages} onChange={function (e) { setF({ ...f, languages: e.target.value }); }}
          placeholder="Which languages can you answer in?" style={inp} />

        {msg ? <p style={{ fontSize: 12.5, margin: '0 0 8px', color: msg === 'Saved.' ? C.primary : C.danger }}>{msg}</p> : null}
        <button onClick={save} disabled={busy} style={btnMain}>{busy ? 'Saving...' : 'Save'}</button>

        <p style={{ margin: '11px 0 0', fontSize: 11, color: C.muted, lineHeight: 1.5 }}>
          Your introduction is separate - open your own card in the Team tab to write it.
        </p>
      </div>
    </>
  );
}

/* ==================== TASKS ==================== */
export function TasksTab({ me }) {
  const [d, setD] = useState(null);
  const [mods, setMods] = useState([]);
  const [all, setAll] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [f, setF] = useState({ mod_id: '', title: '', detail: '', priority: 'normal' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const canManage = me && (me.is_mega || me.is_admin);

  const load = useCallback(function () {
    fetch(API + '/tasks/' + (all ? '?all=1' : ''), { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, [all]);
  useEffect(function () { load(); }, [load]);

  useEffect(function () {
    if (!canManage) return;
    fetch(API + '/mods/', { headers: authHeaders() })
      .then(function (r) { return r.json(); })
      .then(function (j) { setMods(j.mods || []); }).catch(function () {});
  }, [canManage]);

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '2rem 0' }}>{d.error}</p>;

  const create = async function () {
    if (!f.mod_id) { setMsg('Pick who it is for.'); return; }
    if (f.title.trim().length < 3) { setMsg('Give the task a title.'); return; }
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/tasks/create/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(f) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setF({ mod_id: '', title: '', detail: '', priority: 'normal' });
      setShowNew(false);
      load();
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  const act = async function (t, action) {
    let reply = '';
    if (action === 'done') {
      reply = window.prompt('Anything to add about what you did? (optional)') || '';
    }
    try {
      const res = await fetch(API + '/tasks/' + t.id + '/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify({ action: action, reply: reply }) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      load();
    } catch (e) { alert(e.message); }
  };

  const PRI = { low: C.muted, normal: C.text, high: C.gold, urgent: C.danger };

  return (
    <>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 11 }}>
        {canManage ? (
          <button onClick={function () { setAll(!all); }}
            style={{ ...btn, background: all ? C.primaryBg : '#fff', color: all ? C.primary : C.muted, fontWeight: all ? 700 : 400 }}>
            {all ? 'Everyone' : 'Mine only'}
          </button>
        ) : null}
        {canManage ? (
          <button onClick={function () { setShowNew(!showNew); }} style={{ ...btnMain, marginLeft: 'auto' }}>+ Assign a task</button>
        ) : null}
      </div>

      {showNew && canManage ? (
        <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 13, marginBottom: 12 }}>
          <p style={{ margin: '0 0 9px', fontSize: 13.5, fontWeight: 700 }}>Assign a task</p>
          <select value={f.mod_id} onChange={function (e) { setF({ ...f, mod_id: e.target.value }); }} style={inp}>
            <option value="">Who is it for?</option>
            {mods.map(function (m) { return <option key={m.id} value={m.id}>{m.name} ({m.username})</option>; })}
          </select>
          <input value={f.title} onChange={function (e) { setF({ ...f, title: e.target.value }); }}
            placeholder="What needs doing?" style={inp} />
          <textarea value={f.detail} onChange={function (e) { setF({ ...f, detail: e.target.value }); }} rows={3}
            placeholder="Any detail they need (optional)" style={{ ...inp, resize: 'vertical' }} />
          <select value={f.priority} onChange={function (e) { setF({ ...f, priority: e.target.value }); }} style={inp}>
            <option value="low">Low</option>
            <option value="normal">Normal</option>
            <option value="high">High</option>
            <option value="urgent">Urgent</option>
          </select>
          {msg ? <p style={{ fontSize: 12, color: C.danger, margin: '0 0 8px' }}>{msg}</p> : null}
          <div style={{ display: 'flex', gap: 7 }}>
            <button onClick={create} disabled={busy} style={btnMain}>{busy ? 'Sending...' : 'Assign'}</button>
            <button onClick={function () { setShowNew(false); setMsg(''); }} style={btn}>Cancel</button>
          </div>
        </div>
      ) : null}

      {d.tasks.length === 0 ? (
        <p style={{ textAlign: 'center', color: C.muted, fontSize: 12.5, padding: '2rem 1rem' }}>No tasks right now.</p>
      ) : d.tasks.map(function (t) {
        const dn = t.status === 'done';
        return (
          <div key={t.id} style={{ background: '#fff', border: '1px solid ' + (t.is_late ? C.danger : C.border),
                                   borderRadius: 9, padding: '11px 13px', marginBottom: 8, opacity: dn ? 0.7 : 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13.5, fontWeight: 600, textDecoration: dn ? 'line-through' : 'none' }}>{t.title}</span>
              <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: PRI[t.priority] || C.muted }}>
                {t.priority}{t.is_late ? ' - LATE' : ''}
              </span>
            </div>
            {t.detail ? <p style={{ margin: '4px 0', fontSize: 12.5, color: C.text, whiteSpace: 'pre-wrap' }}>{t.detail}</p> : null}
            <p style={{ margin: '3px 0 0', fontSize: 11, color: C.muted }}>
              {t.assigned_to}{t.assigned_by ? ' - from ' + t.assigned_by : ''} - {when(t.created_at)} - {t.status}
            </p>
            {t.reply ? (
              <p style={{ margin: '5px 0 0', fontSize: 11.5, color: C.text, background: C.surface, borderRadius: 6, padding: '5px 8px' }}>
                {t.reply}
              </p>
            ) : null}
            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 7 }}>
              {t.status === 'open' ? <button style={btn} onClick={function () { act(t, 'start'); }}>Start</button> : null}
              {t.status !== 'done' && t.status !== 'cancelled' ? (
                <button style={btnMain} onClick={function () { act(t, 'done'); }}>Mark done</button>
              ) : null}
              {canManage && t.status !== 'cancelled' && t.status !== 'done' ? (
                <button style={{ ...btn, color: C.danger, borderColor: C.danger }} onClick={function () { act(t, 'cancel'); }}>Cancel</button>
              ) : null}
            </div>
          </div>
        );
      })}
    </>
  );
}

/* ==================== ALERTS + BROADCAST ==================== */
export function AlertsTab({ me }) {
  const [d, setD] = useState(null);
  const [mode, setMode] = useState('list');
  const [f, setF] = useState({ kind: 'notice', title: '', body: '', pinned: false });
  const [bc, setBc] = useState({ message: '', level: '', country: '' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const canManage = me && (me.is_mega || me.is_admin);
  const isAdmin = me && me.is_admin;

  const load = useCallback(function () {
    fetch(API + '/alerts/', { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, []);
  useEffect(function () { load(); }, [load]);

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '2rem 0' }}>{d.error}</p>;

  const post = async function () {
    if (f.title.trim().length < 3 || f.body.trim().length < 5) { setMsg('Write a title and a message.'); return; }
    if (f.kind === 'scam' && !window.confirm('Post this scam alert?\n\nEvery active moderator is notified immediately - bell, Discord and Telegram.')) return;
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/alerts/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(f) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setF({ kind: 'notice', title: '', body: '', pinned: false });
      setMode('list');
      load();
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  const broadcast = async function () {
    if (bc.message.trim().length < 5) { setMsg('Write a longer message.'); return; }
    const who = bc.level === 'mega' ? 'all Mega Mods' : bc.level === 'mod' ? 'all Moderators'
              : bc.country ? 'everyone in ' + bc.country : 'the whole team';
    if (!window.confirm('Send this to ' + who + '?\n\nIt cannot be taken back.')) return;
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/broadcast/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(bc) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setMsg('Sent to ' + j.sent + ' people.');
      setBc({ message: '', level: '', country: '' });
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  const KC = { scam: C.danger, notice: C.primary, update: C.gold };

  if (mode === 'new' && canManage) {
    return (
      <div>
        <button onClick={function () { setMode('list'); setMsg(''); }} style={{ ...btn, marginBottom: 10 }}>Back</button>
        <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 13 }}>
          <p style={{ margin: '0 0 9px', fontSize: 13.5, fontWeight: 700 }}>Post to the team</p>
          <div style={{ display: 'flex', gap: 6, marginBottom: 9 }}>
            {[['notice', 'Notice'], ['update', 'Update'], ['scam', 'Scam alert']].map(function (k) {
              const on = f.kind === k[0];
              return <button key={k[0]} onClick={function () { setF({ ...f, kind: k[0] }); }}
                style={{ ...btn, background: on ? C.primaryBg : '#fff',
                         color: on ? (KC[k[0]] || C.primary) : C.muted,
                         borderColor: on ? (KC[k[0]] || C.primary) : C.border, fontWeight: on ? 700 : 400 }}>
                {k[1]}
              </button>;
            })}
          </div>
          {f.kind === 'scam' ? (
            <p style={{ margin: '0 0 9px', fontSize: 11.5, color: C.danger, lineHeight: 1.5 }}>
              A scam alert notifies every active moderator immediately - bell, Discord and Telegram.
            </p>
          ) : null}
          <input value={f.title} onChange={function (e) { setF({ ...f, title: e.target.value }); }}
            placeholder="Title - what is it about?" style={inp} />
          <textarea value={f.body} onChange={function (e) { setF({ ...f, body: e.target.value }); }} rows={5}
            placeholder="The details the team needs" style={{ ...inp, resize: 'vertical' }} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, marginBottom: 10, cursor: 'pointer' }}>
            <input type="checkbox" checked={f.pinned} onChange={function (e) { setF({ ...f, pinned: e.target.checked }); }} />
            Pin it to the top
          </label>
          {msg ? <p style={{ fontSize: 12, color: C.danger, margin: '0 0 8px' }}>{msg}</p> : null}
          <button onClick={post} disabled={busy} style={btnMain}>{busy ? 'Posting...' : 'Post'}</button>
        </div>
      </div>
    );
  }

  if (mode === 'bc' && isAdmin) {
    return (
      <div>
        <button onClick={function () { setMode('list'); setMsg(''); }} style={{ ...btn, marginBottom: 10 }}>Back</button>
        <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 13 }}>
          <p style={{ margin: '0 0 3px', fontSize: 13.5, fontWeight: 700 }}>Message the team</p>
          <p style={{ margin: '0 0 11px', fontSize: 11.5, color: C.muted, lineHeight: 1.5 }}>
            Goes out as a bell notification plus a Discord and Telegram DM.
          </p>
          <select value={bc.level} onChange={function (e) { setBc({ ...bc, level: e.target.value, country: '' }); }} style={inp}>
            <option value="">Everyone</option>
            <option value="mod">Only Moderators</option>
            <option value="mega">Only Mega Mods</option>
          </select>
          <input value={bc.country} onChange={function (e) { setBc({ ...bc, country: e.target.value }); }}
            placeholder="Or just one country (optional)" style={inp} />
          <textarea value={bc.message} onChange={function (e) { setBc({ ...bc, message: e.target.value }); }} rows={5}
            maxLength={500} placeholder="What do you want to tell them?" style={{ ...inp, resize: 'vertical' }} />
          <p style={{ margin: '-4px 0 9px', fontSize: 10.5, color: C.muted, textAlign: 'right' }}>{bc.message.length} / 500</p>
          {msg ? <p style={{ fontSize: 12, margin: '0 0 8px', color: msg.indexOf('Sent') === 0 ? C.primary : C.danger }}>{msg}</p> : null}
          <button onClick={broadcast} disabled={busy} style={{ ...btnMain, background: busy ? '#B4B2A9' : C.purple, borderColor: busy ? '#B4B2A9' : C.purple }}>
            {busy ? 'Sending...' : 'Send'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 11 }}>
        {canManage ? <button onClick={function () { setMode('new'); }} style={btnMain}>+ Post a notice</button> : null}
        {isAdmin ? (
          <button onClick={function () { setMode('bc'); }}
            style={{ ...btn, color: C.purple, borderColor: C.purple, fontWeight: 700, marginLeft: 'auto' }}>
            Message the team
          </button>
        ) : null}
      </div>

      {d.items.length === 0 ? (
        <p style={{ textAlign: 'center', color: C.muted, fontSize: 12.5, padding: '2rem 1rem' }}>Nothing posted yet.</p>
      ) : d.items.map(function (a) {
        return (
          <div key={a.id} style={{ background: a.kind === 'scam' ? '#FDEDEC' : '#fff',
                                   border: '1px solid ' + (a.kind === 'scam' ? C.danger : C.border),
                                   borderRadius: 9, padding: '11px 13px', marginBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13.5, fontWeight: 700, color: a.kind === 'scam' ? C.danger : C.text }}>
                {a.pinned ? 'PINNED - ' : ''}{a.title}
              </span>
              <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: KC[a.kind] || C.muted }}>{a.kind}</span>
            </div>
            <p style={{ margin: '5px 0', fontSize: 12.5, color: C.text, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{a.body}</p>
            <p style={{ margin: 0, fontSize: 10.5, color: C.muted }}>{a.by ? 'by ' + a.by + ' - ' : ''}{when(a.at)}</p>
          </div>
        );
      })}
    </>
  );
}
